
import { CreatePaymentAccountPayload } from "../../payment-processing/merchant-onboarding/PaymentAccountPayload"
import { HttpError, isError } from "../../state/helpers/Error"
import HttpClient from "../../state/helpers/HttpClient"
import { SESSION_TYPE } from "../../utils/payment-account/constants"
import PaymentAccount, { PaymentAccountDto } from "../model/paymentaccount"
import Session from "../model/session"
import SessionService from "./sessionService"


export type RainforestMerchant = {
    sessionKey: string,
    merchantId: string,
    merchantApplicationId: string
}
class PaymentAccountService {

    static httpClient: HttpClient<PaymentAccount, PaymentAccountDto> =
        new HttpClient<PaymentAccount, PaymentAccountDto>(PaymentAccount)


    static async createPaymentAccount(integrationKey: string, payload: CreatePaymentAccountPayload): Promise<PaymentAccount | Error> {
        const res = await this.httpClient.post("/" + integrationKey + "/payment-accounts", payload)
        if (isError(res) && res.payload.error) {
            throw new Error(res.payload.error.message)
        }
        return res as PaymentAccount
    }

    static async createTestPaymentAccount(): Promise<PaymentAccount | Error> {
        const res = await this.httpClient.post("/payment-accounts/test", {})
        if (isError(res) && res.payload.error) {
            throw new Error(res.payload.error.message)
        }
        return res as PaymentAccount
    }

    static async getPaymentAccounts(): Promise<PaymentAccount[] | HttpError> {
        const res = await this.httpClient.get("/payment-accounts")
        if (isError(res)) {
            return res as HttpError
        }
        return res as PaymentAccount[]
    }

    static async getPaymentAccount(paymentAccountId: string): Promise<PaymentAccount | HttpError> {
        const res = await this.httpClient.get(`/payment-accounts/${paymentAccountId}`)
        if (isError(res)) {
            return res as HttpError
        }
        return res as PaymentAccount
    }

    static async updatePaymentAccount(paymentAccountId: string, payload): Promise<PaymentAccount | HttpError> {
        const res = await this.httpClient.patch(`/payment-accounts/${paymentAccountId}`, payload)
        if (isError(res)) {
            return res as HttpError
        }
        return res as PaymentAccount
    }

    static getOnBoardingMerchant = async (paymentAccountId: string): Promise<RainforestMerchant | HttpError | undefined> => {
        const paymentAccount = await PaymentAccountService.getPaymentAccount(paymentAccountId)
        // Payment Account exists
        if (paymentAccount instanceof PaymentAccount) {
            const session = await SessionService.getSession(SESSION_TYPE.ONBOARDING_MERCHANT, paymentAccount.getMerchantId())
            if (!(session instanceof Session)) {
                return session as HttpError
            }
            return {
                sessionKey: session.getSessionKey(),
                merchantId: paymentAccount.getMerchantId(),
                merchantApplicationId: paymentAccount.getOnBoardingApplicationId()
            } as RainforestMerchant
        }
        return paymentAccount as HttpError

    }

}

export default PaymentAccountService




// WEBPACK FOOTER //
// ./src/payment-account/service/paymentAccountService.ts